<template>
  <div class="message-main">
    <div v-bind:class="['message-body', type]">
        <i class="el-icon-remove-outline delete-message" v-if="isDelete" @click="deleteMessage"></i>
        <div class="message-sender" >{{name}}</div>
      <div class="message-content">{{content}}</div>
      <div class="message-time">{{time | formatDate}}</div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Message',
    props: ['id', 'name', 'content', 'time', 'type', 'is-delete'],
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(value).format('YYYY-MM-DD, HH:mm:ss')
        }
      }
    },
      methods: {
          deleteMessage: function () {
              this.$confirm('メッセージを削除します。よろしいですか？', '', {
                  confirmButtonText: '削除する',
                  cancelButtonText: 'キャンセル',
                  center: true,
                  confirmButtonClass: 'btn-msg-box'
              }).then(() => {
                  this.$emit('deleteMessage', this.id)
              }).catch(() => {})
          }
      }
  }
</script>

<style scoped>
  .message-main {
    margin-bottom: 15px;
  }
  .message-main::after {
    content: "";
    clear: both;
    display: block;
  }
  .message-body {
      position: relative;
    max-width: 65%;
    border-radius: 4px;
    padding: 5px 15px;
  }
  .message-body.myself {
    float: right;
    clear: right;
    background-color: #f9efd0;
    border: 1px solid #f9efd0;
  }
  .message-body.other {
    float: left;
    clear: left;
    background-color: #f1f0f0;
    border: 1px solid #f1f0f0;
  }
  .message-body.other-admin {
    float: right;
    clear: right;
    background-color: #ffdede;
    border: 1px solid #ffdede;
  }
  .message-sender {
    font-weight: bold;
    font-size: 16px;
  }
  .message-content {
    white-space: pre-wrap;
    font-size: 14px;
  }
  .message-time {
    text-align: right;
    font-size: 12px;
    color: #5a5a5a;
  }
    .delete-message {
        font-size: 20px;
        cursor: pointer;
        position: absolute;
        right: -8px;
        top: -8px;
    }
</style>
